<template>
  <el-dialog
    class="create-entity"
    :title="!disabled ? '添加数据实体' : '编辑数据实体'"
    :visible="dialog"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
    fullscreen
    v-loading.fullscreen="loading"
  >
    <el-form
      ref="ruleform"
      :model="ruleForm"
      :rules="rules"
      label-width="70px"
      size="small"
    >
      <el-row>
        <el-col :span="8">
          <el-form-item label="名称" prop="name">
            <el-input
              v-model="ruleForm.name"
              maxlength="16"
              show-word-limit
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="编码" prop="code">
            <el-input
              v-model="ruleForm.code"
              :disabled="disabled"
              maxlength="32"
              show-word-limit
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="数据源" prop="dsName">
            <el-select
              filterable
              clearable
              v-model="ruleForm.dsName"
              @change="getDbOptions"
              :disabled="disabled"
            >
              <el-option
                v-for="(item, index) in dsOptions"
                :key="index"
                :label="item.name"
                :value="item.name"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="数据库" prop="dbName">
            <el-select
              filterable
              clearable
              v-model="ruleForm.dbName"
              @change="getTableOptions"
              :disabled="disabled"
            >
              <el-option
                v-for="(item, index) in dbOptions"
                :key="index"
                :label="item.name"
                :value="item.name"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="数据表" prop="tableName">
            <el-select
              filterable
              clearable
              v-model="ruleForm.tableName"
              @change="getPre"
              :disabled="disabled"
            >
              <el-option
                v-for="(item, index) in tableOptions"
                :key="index"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="label">
        数据列设置
        <span title="选中列数" v-if="selectCol">({{ selectCol }})</span>
      </div>
      <div class="col header">
        <div class="columnName">列名</div>
        <div class="type">类型</div>
        <div class="attrName">属性名</div>
        <div class="attrType">实体列类型</div>
        <div class="attrExpression">属性表达式</div>
        <div class="description">描述</div>
        <div class="projectable">
          <el-checkbox
            v-model="selectAll"
            :indeterminate="isIndeterminate"
            @change="selectAllCol"
          >
          </el-checkbox>
          <span style="margin-left: 5px;">查询投影</span>
        </div>
        <div class="queryFilters">查询过滤</div>
      </div>
      <RecycleScroller
        :items="ruleForm.entitySetting.columnSettings"
        :item-size="45"
        key-field="columnName"
        class="scroller"
        #default="{item,index}"
        :buffer="180"
      >
        <div class="col" :style="index === 0 ? 'border: 0' : ''">
          <div class="columnName">{{ item.columnName }}</div>
          <div class="type">{{ item.type }}</div>
          <div class="attrName">
            <el-input size="mini" v-model="item.attrName"></el-input>
          </div>
          <div class="attrType">
            <el-select size="mini" v-model="item.attrType">
              <el-option
                v-for="(item, index) in typeOptions"
                :key="index"
                :value="item"
              >
                {{ item }}
              </el-option>
            </el-select>
          </div>
          <div class="attrExpression">
            <el-input size="mini" v-model="item.attrExpression"></el-input>
          </div>
          <div class="description">
            <el-input size="mini" v-model="item.description"></el-input>
          </div>
          <div class="projectable">
            <el-checkbox
              v-model="item.projectable"
              @change="groupByRemove(index)"
            ></el-checkbox>
          </div>
          <div class="queryFilters">
            <el-checkbox-group v-model="item.queryFilters" size="mini">
              <el-checkbox-button v-for="f in filters" :label="f" :key="f">{{
                f
              }}</el-checkbox-button>
            </el-checkbox-group>
          </div>
        </div>
      </RecycleScroller>

      <el-form-item label="分组设置" label-width="100px">
        <el-col :span="8">
          <el-select v-model="ruleForm.entitySetting.groupByAttrs" multiple>
            <template
              v-for="(item, index) in this.ruleForm.entitySetting
                .columnSettings"
            >
              <el-option
                v-if="item.projectable"
                :key="index"
                :label="item.attrName"
                :value="index"
              ></el-option>
            </template>
          </el-select>
        </el-col>
      </el-form-item>
      <el-form-item label="数据条数控制" label-width="100px">
        <el-checkbox v-model="ruleForm.entitySetting.limitAble"></el-checkbox>
      </el-form-item>
      <el-form-item label="默认返回条数" label-width="100px">
        <el-col :span="8">
          <el-input v-model="ruleForm.entitySetting.queryMaxSize"></el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="描述" prop="description" label-width="100px">
        <el-col :span="15">
          <el-input
            type="textarea"
            v-model="ruleForm.description"
            :rows="4"
          ></el-input>
        </el-col>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button :disabled="loading" size="small" @click="quit"
        >取 消</el-button
      >
      <el-button :loading="loading" size="small" type="primary" @click="submit">
        {{ !disabled ? "创 建" : "编 辑" }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "CreateEntity",
  props: {
    dialog: {
      type: Boolean
    },
    propData: {
      type: Object
    }
  },
  data() {
    return {
      loading: false,
      filters: ["RANGE", "IN", "NOT_IN", "NULL", "DISTINCT"],
      typeOptions: [
        "STRING",
        "DOUBLE",
        "FLOAT",
        "INT",
        "LONG",
        "DATE",
        "TIMESTAMP",
        "BOOLEAN",
        "TIME",
        "DECIMAL"
      ],
      ruleForm: {
        name: "",
        code: "",
        dsName: "",
        dbName: "",
        tableName: "",
        description: "",
        entitySetting: {
          groupByAttrs: [],
          limitAble: true,
          queryMaxSize: 2000,
          columnSettings: []
        }
      },
      rules: {
        name: [{ required: true, message: "请输入名称", trigger: "blur" }],
        code: [{ required: true, message: "请输入编码", trigger: "blur" }],
        dsName: [
          { required: true, message: "请选择数据源", trigger: "change" }
        ],
        dbName: [
          { required: true, message: "请选择数据库", trigger: "change" }
        ],
        tableName: [
          { required: true, message: "请选择数据表", trigger: "change" }
        ],
        description: [
          { required: true, message: "请输入描述", trigger: "blur" }
        ]
      },
      dsOptions: [],
      dbOptions: [],
      tableOptions: [],
      selectCol: "",
      selectAll: false,
      isIndeterminate: false
    };
  },
  computed: {
    disabled() {
      return Object.keys(this.propData).length > 0;
    }
  },
  watch: {
    propData(val) {
      if (!this.disabled) return;
      let data = JSON.parse(JSON.stringify(val));
      data.entitySetting.groupByAttrs = this.setGroupByToIndex(
        val.entitySetting.groupByAttrs,
        val.entitySetting.columnSettings
      );
      this.ruleForm = data;
      this.setSelectCol();
    }
  },
  mounted() {
    this.getDsOptions();
  },
  methods: {
    getDsOptions() {
      this.$http.get("/gavial/v1/dw/view/datasource").then(res => {
        this.dsOptions = res.data.data;
      });
    },
    getDbOptions(dsName) {
      if (!dsName) return;
      this.dbOptions = [];
      this.ruleForm.dbName = "";
      this.tableOptions = [];
      this.ruleForm.tableName = "";
      this.$http
        .get(`/gavial/v1/dw/view/databases?dsName=${dsName}`)
        .then(res => {
          this.dbOptions = res.data.data;
        });
    },
    getTableOptions(dbName) {
      if (!dbName) return;
      this.tableOptions = [];
      this.ruleForm.tableName = "";
      let dbId = this.dbOptions.find(item => item.name === dbName).id;
      this.$http.get(`/gavial/v1/dw/view/table?id=${dbId}`).then(res => {
        this.tableOptions = res.data.data;
      });
    },
    getPre(tableName) {
      if (!tableName) return;
      this.$http
        .get(
          `/gavial/v1/di/create/pre?dsName=${this.ruleForm.dsName}&dbName=${this.ruleForm.dbName}&tableName=${tableName}`
        )
        .then(res => {
          let data = res.data.data;
          let {
            name,
            code,
            dsName,
            dbName,
            tableName,
            description
          } = this.ruleForm;

          this.ruleForm = Object.assign({}, data, {
            name,
            code,
            dsName,
            dbName,
            tableName,
            description
          });
          this.setSelectCol();
        });
    },
    // 根据 index 获取 attrName
    setGroupByFromIndex(groupByAttrs, columnSettings) {
      if (groupByAttrs.length === 0) return [];
      return groupByAttrs.map(index => columnSettings[index].attrName);
    },
    // 根据 attrName 获取 index
    setGroupByToIndex(groupByAttrs, columnSettings) {
      if (groupByAttrs.length === 0) return [];
      return groupByAttrs.map(attrName =>
        columnSettings.findIndex(item => item.attrName === attrName)
      );
    },
    groupByRemove(index) {
      let i = this.ruleForm.entitySetting.groupByAttrs.findIndex(
        item => item === index
      );
      if (i >= 0) {
        this.ruleForm.entitySetting.groupByAttrs.splice(i, 1);
      }
      this.setSelectCol();
    },
    setSelectCol() {
      let length = this.ruleForm.entitySetting.columnSettings.length;
      let num = 0;
      this.ruleForm.entitySetting.columnSettings.forEach(item => {
        if (item.projectable) {
          num++;
        }
      });
      this.selectCol = `${num}/${length}`;
      if (num === length) {
        this.selectAll = true;
        this.isIndeterminate = false;
      } else if (num > 0) {
        this.selectAll = false;
        this.isIndeterminate = true;
      } else {
        this.selectAll = false;
        this.isIndeterminate = false;
      }
    },
    selectAllCol(val) {
      this.isIndeterminate = false;

      this.ruleForm.entitySetting.columnSettings.forEach(item => {
        if (val) {
          item.projectable = true;
        } else {
          item.projectable = false;
        }
      });
      let length = this.ruleForm.entitySetting.columnSettings.length;
      if (val) {
        this.selectCol = `${length}/${length}`;
      } else {
        this.selectCol = `0/${length}`;
        this.ruleForm.entitySetting.groupByAttrs = [];
      }
    },
    quit() {
      this.$emit("update:dialog", false);
      this.ruleForm = {
        name: "",
        code: "",
        dsName: "",
        dbName: "",
        tableName: "",
        description: "",
        entitySetting: {
          groupByAttrs: [],
          limitAble: true,
          queryMaxSize: 2000,
          columnSettings: []
        }
      };
      this.$nextTick(() => {
        this.$refs.ruleform.clearValidate();
      });
    },
    submit() {
      this.$refs.ruleform.validate(valid => {
        if (valid) {
          this.loading = true;
          this.create(
            `/gavial/v1/di/${this.disabled ? "edit" : "create"}/submit`
          );
        }
      });
    },
    create(url) {
      let data = JSON.parse(JSON.stringify(this.ruleForm));
      data.entitySetting.groupByAttrs = this.setGroupByFromIndex(
        this.ruleForm.entitySetting.groupByAttrs,
        this.ruleForm.entitySetting.columnSettings
      );
      this.$http
        .post(url, data)
        .then(() => {
          this.$message({
            type: "success",
            message: `${data.name} 以${this.disabled ? "修改" : "创建"}！`
          });
          this.quit();
          this.$emit("refush");
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.label {
  line-height: 1;
  margin-bottom: 10px;
}
.el-select {
  width: 100%;
}
.el-table {
  margin-bottom: 22px;
}
.dialog-footer {
  width: 100%;
  text-align: center;
  .el-button {
    min-width: 100px;
    & + .el-button {
      margin-left: 50px;
    }
  }
}
.scroller {
  max-height: 600px;
  border: 1px solid #eee;
  margin-bottom: 20px;
}
.col {
  height: 45px;
  display: flex;
  align-items: center;
  border-top: 1px solid #eee;
  &.header {
    border-left: 1px solid #eee;
    border-right: 1px solid #eee;
    background: #f7f7f7;
    & > div {
      font-weight: 400;
      span {
        font-weight: 400;
      }
    }
  }
  & > div {
    padding: 0 8px;
    flex: 1 1 190px;
  }
  .columnName {
    flex: 0 0 150px;
  }
  .type {
    flex: 0 0 80px;
  }
  .projectable {
    flex: 0 0 77px;
    text-align: center;
  }
  .queryFilters {
    flex: 0 0 339px;
  }
}
</style>
